/**
 * Pastila de severitate - `adm-pill od-audit-sev od-audit-sev-<severitate>`,
 * cu culorile din `audit.css`. Aceeasi pastila in registru, in fotografie si
 * in document: o severitate trebuie sa arate la fel oriunde e citita.
 */
export function SeverityPill({ severity }: { severity: string }) {
  return <span className={`adm-pill od-audit-sev od-audit-sev-${severity.toLowerCase()}`}>{severity}</span>
}
